var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateFileActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1.2,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KA---03",
    transform: "translate(-1400.000000, -370.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/16px/Info/Create/Active",
    transform: "translate(1400.000000, 370.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,10.15 C13,9.68055796 13.380558,9.3 13.85,9.3 C14.319442,9.3 14.7,9.68055796 14.7,10.15 L14.7,14.2833333 C14.7,15.2314222 13.9314222,16 12.9833333,16 L1.71666667,16 C0.768577846,16 4.58522109e-14,15.2314222 4.58522109e-14,14.2833333 L4.76285678e-14,3.01666667 C4.76285678e-14,2.06857785 0.768577846,1.3 1.71666667,1.3 L5.85,1.3 C6.31944204,1.3 6.7,1.68055796 6.7,2.15 C6.7,2.61944204 6.31944204,3 5.85,3 L1.71666667,3 C1.70746192,3 1.7,3.00746192 1.7,3.01666667 L1.7,14.2833333 C1.7,14.2925381 1.70746192,14.3 1.71666667,14.3 L12.9833333,14.3 C12.9925381,14.3 13,14.2925381 13,14.2833333 L13,10.15 Z M15.1,3.6 C15.5970563,3.6 16,4.00294373 16,4.5 C16,4.99705627 15.5970563,5.4 15.1,5.4 L12.4,5.4 L12.4,8.1 C12.4,8.59705627 11.9970563,9 11.5,9 C11.0029437,9 10.6,8.59705627 10.6,8.1 L10.6,5.4 L7.9,5.4 C7.40294373,5.4 7,4.99705627 7,4.5 C7,4.00294373 7.40294373,3.6 7.9,3.6 L10.6,3.6 L10.6,0.9 C10.6,0.402943725 11.0029437,-3.14970272e-13 11.5,-3.13860049e-13 C11.9970563,-3.12638804e-13 12.4,0.402943725 12.4,0.9 L12.4,3.6 L15.1,3.6 Z",
    fill: "#3368FF",
    fillRule: "nonzero",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateFileActive);
export default __webpack_public_path__ + "static/media/create-file-active.dba6739090de900c164aa7f18b57587e.svg";
export { ForwardRef as ReactComponent };